import { useState } from 'react';

import type { SessionNoteStatus } from '@/entities/session';
import {
    SheetBody,
    SheetDescription,
    SheetHeader,
    SheetPanel,
    SheetTitle,
} from '@/shared/ui/panels/sheet-panel';

import { PastSessionsSearch } from './all-past-sessions/past-sessions-search';
import { PastSessionsTable } from './all-past-sessions/past-sessions-table';

export function AllPastSessions() {
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState<SessionNoteStatus | undefined>(undefined);

    return (
        <SheetPanel
            type="sessions/past"
            side="right"
            size="large"
            onOpenAutoFocus={(e) => e.preventDefault()}
            className="gap-4"
        >
            <SheetHeader>
                <SheetTitle>All Past Sessions</SheetTitle>
                <SheetDescription className="sr-only">
                    A list of all past client sessions.
                </SheetDescription>
            </SheetHeader>

            <SheetBody className="flex-1 flex flex-col pt-5 min-h-0 overflow-hidden">
                <PastSessionsSearch
                    onSearchDebouncedChange={setDebouncedSearchTerm}
                    onStatusChange={setFilterStatus}
                />
                <PastSessionsTable status={filterStatus} search={debouncedSearchTerm} />
            </SheetBody>
        </SheetPanel>
    );
}
